/**
 * Left & Right Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initLeftRight() {
        const blocks = document.querySelectorAll('.left-right');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] left-right block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLeftRight);
    } else {
        initLeftRight();
    }
})();